document.addEventListener("DOMContentLoaded", function() {

    // LightGallery inicializace
    // =========================
    if(typeof (lightGallery) === 'undefined')
        return;

    (function () {
        let gallery = document.querySelectorAll('.JS-lightgallery');
        if(typeof(gallery) === 'undefined' || gallery === null)
            return;

        gallery.forEach(function (el) {
            lightGallery(el, {
                selector: '.JS-lightgallery-item',
                thumbnail: true,
                animateThumb: true,
                showThumbByDefault: true,
                zoom: false,
                exThumbImage: 'data-exthumbimage',
                closable: false,
            });
        });


        let thumbs = document.querySelector('.thumbnail-container');
        if(typeof(thumbs) === 'undefined' || thumbs === null)
            return;

        lightGallery(thumbs);
    }());
});